module.exports = __webpack_public_path__ + "media/images/smart_phone/products/meat_bun-2bcf79c83e81f40a05f50e4184ef8980.jpeg";